<template>
  <b-card>
    <b-card-header>
      <i class="icon-note"></i> Detail Partner Transaction
      <div class="card-header-actions">
        <a
          class="card-header-action"
          href="partner-transaction"
          rel="noreferrer noopener"
        >
          <small class="text-muted">Back</small>
        </a>
      </div>
    </b-card-header>
    <br />
    <table>
      <tr>
        <td><strong>Notify Date</strong></td>
        <td>{{ this.notify_date }}</td>
      </tr>
      <tr>
        <td><strong>Transaction Date</strong></td>
        <td>{{ this.created_at }}</td>
      </tr>
      <tr>
        <td><strong>User</strong></td>
        <td>{{ this.user }}</td>
      </tr>
      <tr>
        <td><strong>Transaction Type</strong></td>
        <td>{{ this.transaction_type }}</td>
      </tr>
      <tr>
        <td><strong>Partner</strong></td>
        <td>{{ this.partner }}</td>
      </tr>
      <tr>
        <td><strong>Partner Invoice No.</strong></td>
        <td>{{ this.partner_invoice }}</td>
      </tr>
      <tr>
        <td><strong>Treasury Invoice No.</strong></td>
        <td>{{ this.invoice }}</td>
      </tr>
      <tr>
        <td><strong>Description</strong></td>
        <td>
          <strong>{{ this.description }}</strong>
        </td>
      </tr>
      <tr>
        <td><strong>Gold Amount</strong></td>
        <td>{{ this.gold_amount }}</td>
      </tr>
      <tr>
        <td><strong>IDR Amount</strong></td>
        <td>{{ this.amount }}</td>
      </tr>
      <tr>
        <td><strong>Commission</strong></td>
        <td>{{ this.commission }}</td>
      </tr>
      <tr>
        <td><strong>Gold Buy Price</strong></td>
        <td>{{ this.buying_rate }}</td>
      </tr>
      <tr>
        <td><strong>Gold Sell Price</strong></td>
        <td>{{ this.selling_rate }}</td>
      </tr>
      <tr>
        <td><strong>Payment Method</strong></td>
        <td>{{ this.payment_method }}</td>
      </tr>
      <tr>
        <td><strong>Admin Fee</strong></td>
        <td>{{ this.admin_fee }}</td>
      </tr>
      <tr>
        <td><strong>Transaction Total Amount</strong></td>
        <td>{{ this.trx_amount }}</td>
      </tr>
      <tr>
        <td><strong>Transaction Status</strong></td>
        <td>{{ this.status }}</td>
      </tr>
    </table>
  </b-card>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      created_at: "",
      notify_date: "",
      user: "",
      transaction_type: "",
      invoice: "",
      partner_invoice: "",
      partner: "",
      description: "",
      amount: "",
      gold_amount: "",
      buying_rate: "",
      selling_rate: "",
      admin_fee: "",
      payment_method: "",
      commission: "",
      trx_amount: "",
      status: "",
      errors: {
        code: "",
        message: "",
        status: ""
      }
    };
  },
  created() {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("access_token")}`;
    this.$http
      .get(`partner-transaction/` + atob(this.$route.params.id))
      .then(result => {
        let res = result.data.data;
        this.notify_date = res.notify_date;
        this.created_at = res.created_at;
        this.user = res.users.name + "(" + res.users.email + ")";
        this.transaction_type = res.transaction_type;
        this.partner = res.partner;
        this.partner_invoice = res.partner_invoice;
        this.invoice = res.invoice_number;
        this.description = res.description;
        this.gold_amount = res.gold_amount;
        this.amount = res.amount;
        this.commission = res.commission;
        this.buying_rate = res.buying_rate;
        this.selling_rate = res.selling_rate;
        this.payment_method = res.payment_method;
        this.admin_fee = res.admin_fee;
        this.status = res.status;
        this.trx_amount = res.total;
      })
      .catch(error => {
        if (error.response) {
          this.errors.code = error.response.status;
          this.errors.message = error.response.data.meta.message;
          this.errors.status = error.response.data.meta.code;
        }
      });
  }
};
</script>

<style>
table {
  border-collapse: collapse;
  width: 100%;
}

td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}
</style>
